


export class Settings {
    static SETTING_LASTLOAD = 'SETTING_LASTLOAD';
    static SETTING_LASTLOGGED = 'SETTING_LASTLOGGED';
    static SETTING_ENVIRONMENT = 'SETTING_ENV';
    static SETTING_GRIDSTATE = 'SETTING_GRIDSTATE';
    static SETTING_GRIDCOLUMNS = 'SETTING_GRIDCOLUMNS';
    static SETTING_LASTVERSION = 'SETTING_LASTVERSION';
    static SETTING_LASTSUB = 'SETTING_LASTSUB';
    static SETTING_LASTROUTE = 'SETTING_LASTROUTE';
    static SETTING_AR_GRIDSTATE = 'SETTING_AR_GRIDSTATE';
    static SETTING_ADMIN_GRIDSTATE = 'SETTING_ADMIN_GRIDSTATE';
    static SETTING_SERVER = 'SETTING_USESERVER';
    static SETTING_USEAPI = 'SETTING_USEAPI';


    static SETTING_GRID_COLUMNS_VISIBLE = 'SETTING_GRID_COLUMNS_VISIBLE';
    static SETTING_DEPRECATED_TOOLS_VISIBLE = 'SETTING_DEPRECATED_TOOLS_VISIBLE';
    static SETTING_FLOW_LINKS_VISIBLE = 'SETTING_FLOW_LINKS_VISIBLE';
    static SETTING_AUTO_REFRESH_HOURS = 'SETTING_AUTO_REFRESH_HOURS';
    static SETTING_RUN_SCAN_GROUPS = 'SETTING_RUN_SCAN_GROUPS';

    static SETTING_FREE_REMAIN = 'SETTING_FREE_REMAIN';
    static SETTING_FREE_RESET = 'SETTING_FREE_RESET';

    static SETTING_KEYS = [
        // Settings.SETTING_LASTLOAD,
        // Settings.SETTING_LASTLOGGED,
        Settings.SETTING_ENVIRONMENT,
        Settings.SETTING_LASTVERSION,
        Settings.SETTING_LASTSUB,
        // Settings.SETTING_LASTROUTE,
        // Settings.SETTING_GRIDSTATE,
        // Settings.SETTING_AR_GRIDSTATE,
        // Settings.SETTING_ADMIN_GRIDSTATE
    ];

    '_id': string = 'settings';
    value: any;
}
